import { EAction } from '@pushflow/types/poker/enums'

export enum ETableSound {
  WIN = 'WIN',
  FOLD = EAction.FOLD,
  CHECK = EAction.CHECK,
  BET = EAction.BET,
  CALL = EAction.CALL,
  RAISE = EAction.RAISE,
  ALL_IN = EAction.ALL_IN,
  DEAL = 'DEAL',
  HAND_START = 'HAND_START',
  HAND_END = 'HAND_END',
  CARD_DROP = 'CARD_DROP',
  USERS_TURN = 'USERS_TURN',
  TIMEOUT_WARNING = 'TIMEOUT_WARNING',
  CHAT_MESSAGE = 'CHAT_MESSAGE',
}
